import { useSegmentGroupsQuery } from "modules/segments/hooks/useSegmentGroupsQuery"
import { Loading } from "modules/shared/components/Loading"
import { SegmentGroupCard } from "./SegmentGroupCard"

export function SegmentsGroupsList() {
  const { data: segmentGroups, isPending } = useSegmentGroupsQuery()

  if (isPending) {
    return (
      <div className="w-full">
        <Loading />
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      {segmentGroups?.map((segmentGroup) => (
        <SegmentGroupCard key={segmentGroup.id} segmentGroup={segmentGroup} />
      ))}
    </div>
  )
}
